function getOrdinalSuffix(numStr) {
    const num = parseInt(numStr, 10);

    if (isNaN(num)) {
        return `${numStr} is not a valid number`;
    }

    const lastDigit = num % 10;
    const lastTwoDigits = num % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
        return 'th';
    }

    switch (lastDigit) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
}

export default getOrdinalSuffix;

function stringOneLetterDifference(original, newString) {
    if (newString.length - original.length !== 1) {
        return null;
    }

    // Create a frequency count of characters in the original string
    const freq = {};
    for (let char of original) {
        freq[char] = (freq[char] || 0) + 1;
    }

    // Iterate through newString to find the extra character
    for (let char of newString) {
        if (!freq[char]) {
            // This character wasn't in the original or was already "used up"
            return char;
        }
        freq[char]--;
    }

    // If we somehow get here, no new character was found (unlikely with length check)
    return null;
}

export {stringOneLetterDifference};